/**
 * Copyright © 2025 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

export const SEND_PHONE_NUMBER_VERIFICATION_CODE = gql`
  mutation SendPhoneNumberVerificationCode {
    sendPhoneNumberVerificationCode
  }
`
